'use es6';

import * as ActionTypes from 'MeetingsLib/redux/actions/ActionTypes';
import { canSubmitBooking, canSubmitMeetingTime } from 'MeetingsLib/selectors/AutoSubmitSelector';
import { getIsLegitimateInterest, getRecaptchaEnabled } from 'MeetingsLib/selectors/BookInfoSelectors';
import { bookMeeting, rescheduleMeeting } from './BookActions';
import { invokeChallenge } from './RecaptchaActions';
export function setEmailForm(email) {
  return {
    type: ActionTypes.SET_EMAIL_FORM,
    payload: email
  };
}
export function resetEmailForm() {
  return {
    type: ActionTypes.RESET_EMAIL_FORM
  };
}
export function setEventDate(dateString) {
  return {
    type: ActionTypes.SET_EVENT_DATE,
    date: dateString
  };
}
export function resetEventDate() {
  return {
    type: ActionTypes.SET_EVENT_DATE,
    date: null
  };
}
export var setEventDateTime = function setEventDateTime(millisDateTime) {
  return function (dispatch, getState) {
    dispatch({
      type: ActionTypes.SET_EVENT_DATE_TIME,
      dateTime: millisDateTime
    });
    var state = getState();

    if (canSubmitBooking(state)) {
      if (getRecaptchaEnabled(state)) {
        return;
      }

      dispatch(bookMeeting());
    }
  };
};
export var resetEventDateTime = function resetEventDateTime() {
  return {
    type: ActionTypes.SET_EVENT_DATE_TIME,
    dateTime: null
  };
};
export function setEventDuration(duration) {
  return {
    type: ActionTypes.SET_EVENT_DURATION,
    duration: duration
  };
}
export function setGivenConsent(checkbox, checked) {
  return {
    type: ActionTypes.SET_GIVEN_CONSENT,
    communicationTypeId: checkbox.communicationTypeId,
    consented: checked
  };
}
export var submitConsentResponses = function submitConsentResponses(stagedLegalConsentResponses) {
  return function (dispatch, getState) {
    dispatch({
      type: ActionTypes.SET_CONSENT_RESPONSES,
      payload: stagedLegalConsentResponses
    });

    if (getIsLegitimateInterest(getState())) {
      dispatch({
        type: ActionTypes.SET_LEGITIMATE_INTEREST_CONFIRMED
      });
    }

    var state = getState();

    if (canSubmitBooking(state)) {
      if (getRecaptchaEnabled(state)) {
        dispatch(invokeChallenge());
        return;
      }

      dispatch(bookMeeting());
    }
  };
};
export function resetConsentResponses() {
  return {
    type: ActionTypes.RESET_CONSENT_RESPONSES
  };
}
export function setTimezone(timezone) {
  return {
    type: ActionTypes.SET_TIMEZONE,
    timezone: timezone
  };
}
export function setFormValue(formFieldName, formFieldValue) {
  return {
    type: ActionTypes.SET_FORM_FIELD,
    payload: {
      fieldName: formFieldName,
      fieldValue: formFieldValue
    }
  };
}
export function resetFormState() {
  return {
    type: ActionTypes.RESET_FORM_STATE
  };
}
export var setFormState = function setFormState(stagedFormState) {
  return function (dispatch, getState) {
    dispatch({
      type: ActionTypes.SET_FORM_STATE,
      payload: stagedFormState
    });
    var state = getState();
    var event = state.bookingLifecycle.event,
        isRescheduling = state.isRescheduling;

    if (isRescheduling && canSubmitMeetingTime(state)) {
      return dispatch(rescheduleMeeting(event));
    }

    if (canSubmitBooking(state)) {
      if (getRecaptchaEnabled(state)) {
        dispatch(invokeChallenge());
        return Promise.resolve();
      }

      return dispatch(bookMeeting());
    }

    return Promise.resolve();
  };
};